{
    "Page_Title": "Azioni amministrative",
    "Action_Label_MC": "Effettua una chiamata",
    "Action_Label_MCC": "Chiamata di consulenza",
    "Action_Label_MDT": "Tono DTMF",
    "Action_Label_CC": "Chiamata chiara (tramite controllo chiamate)",
    "Action_Label_CCCM": "Chiamata chiara (tramite modello di chiamata)",
    "Action_Label_CX": "Connessione chiara",
    "Action_Label_AC": "Rispondi alla chiamata",
    "Action_Label_HD": "Metti in attesa la chiamata",
    "Action_Label_PC": "Chiamata al parco",
    "Action_Label_RC": "Recupera chiamata",
    "Action_Label_ATC": "Chiamata alternativa",
    "Action_Label_PUC": "Chiamata di risposta",
    "Action_Label_TO": "Trasferisci in un solo passaggio",
    "Action_Label_TR": "Trasferimento completato",
    "Action_Label_DF": "Devia\/Devia chiamata",
    "Action_Label_MONC": "Collegamento del monitor",
    "Action_Label_REC": "Registra chiamata",
    "Action_Label_CBMSG": "Registrati per la richiamata",
    "Action_Label_CO": "Partecipa alla conferenza",
    "Action_Label_MES": "Monitorare l'avvio",
    "Action_Label_MEP": "Monitorare l'arresto",
    "Action_Label_SDND": "Imposta lo stato DNS",
    "Action_Label_SACD": "Imposta lo stato ACD",
    "Action_Label_SFWD": "Imposta stato in avanti",
    "Action_Label_SACC": "Imposta codice account",
    "Action_Label_SPWD": "Imposta password entità",
    "Action_Label_QDND": "Richiedi lo stato DND",
    "Action_Label_QACD": "Query sullo stato ACD",
    "Action_Label_QFWD": "Stato di inoltro della query",
    "Action_Label_SPC": "Chiamata istantanea",
    "Action_Label_SPD": "Dispositivo di istantanea",
    "AcdOption_SignIn": "Registrazione",
    "AcdOption_SignOut": "Disconnessione",
    "AcdOption_Available": "Disponibile",
    "AcdOption_NotAvailable": "Non disponibile",
    "AcdOption_AlertingAcd": "Avviso (ACD)",
    "AcdOption_AlertingNonAcd": "Avviso (non ACD)",
    "AcdOption_BusyAcd": "Occupato (ACD)",
    "AcdOption_BusyNonAcd": "Occupato (non ACD)",
    "AcdOption_BusySupervisor": "Occupato (Supervisore)",
    "AcdOption_AcdDnd": "ACD-DND",
    "AcdOption_WrapUp": "Incartare",
    "ForwardOption_None": "Nessuno",
    "ForwardOption_Immediate": "Immediato",
    "ForwardOption_OnBusy": "Su occupato",
    "ForwardOption_NoAnswer": "Nessuna risposta",
    "ForwardOption_OnDnd": "Su DND",
    "ForwardOption_OnOos": "Su OOS",
    "Field_Label_DeviceMain": "Dispositivo",
    "Field_Label_Destination": "Destinazione",
    "Field_Label_CallIDMain": "ID chiamata attivo",
    "Field_Label_DestinationAutoPrefix": "Prefisso automatico di destinazione?",
    "Field_Label_CallIDHeld": "Altro CallID",
    "Field_Label_DTMFTones": "Toni DTMF",
    "Field_Label_ParkLocation": "Posizione del parco",
    "Field_Label_OtherCallID": "Altro CallID",
    "Field_Label_DeviceToPickupAt": "Dispositivo da ritirare a",
    "Field_Label_CallParked": "Chiamata parcheggiata",
    "Field_Label_MonitorType": "Tipo di monitor",
    "Field_Label_Password": "Password",
    "Field_Label_UseSecurePassword": "Utilizzare una password sicura?",
    "Field_Label_MonitorCrossRefID": "ID di riferimento incrociato del monitor",
    "Field_Label_IsDND": "Non disturbare attivato\/disattivato",
    "Field_Label_AgentID": "ID agente",
    "Field_Label_ACDGroup": "Gruppo ACD",
    "Field_Label_ACDStateReasonTextID": "ACDStateReasonTextID",
    "Field_Label_ACDStatus": "Stato ACD",
    "Field_Label_ForwardMode": "Stato in avanti",
    "Field_Label_AccountCode": "Codice account",
    "Field_Label_PasswordOld": "Vecchia password",
    "Field_Label_PasswordNew": "Nuova password",
    "Field_Label_TelephonyServer": "Server di telefonia",
    "Field_Label_Partition": "Partizione",
    "Field_Label_CME": "ECM",
    "Action_Button_Label_Execute": "Eseguire",
    "Action_Button_Label_Reset": "Reset",
    "NAME": "AdminActionsLanguage",
    "Action_Label": "Azione",
    "Action_Label_GUC": "Ottieni la politica di conformità dell'utente",
    "Action_Label_AAP": "Applica la politica di acquisizione di Akixi",
    "Action_Label_QPS": "Query sullo stato di presenza",
    "Action_Label_DUP": "Elimina la policy utente",
    "Action_Label_GT": "Ottieni inquilino",
    "Action_Label_DT": "Elimina inquilino",
    "Action_Label_GU": "Ottieni utenti",
    "Action_Label_GVA": "Ottieni app vocali",
    "Field_Label_SilentMonitor": "Monitor silenzioso",
    "Field_Label_ForcedIntrude": "Intrusione forzata",
    "Field_Label_Policies": "Politiche"
}